import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProcessingSpinnerProps {
  message?: string;
  className?: string;
}

export function ProcessingSpinner({
  message = "Processing...",
  className,
}: ProcessingSpinnerProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-5 py-14",
        className
      )}
      role="status"
      aria-live="polite"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-primary/10 animate-pulse" />
        <Loader2
          className="size-12 animate-spin text-primary relative z-10"
          aria-hidden="true"
        />
      </div>
      <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
        {message}
      </p>
      <span className="sr-only">{message}</span>
    </div>
  );
}

/*
 * Usage Example:
 *
 * import { ProcessingSpinner } from "@/components/processing-spinner";
 *
 * function ProcessingState() {
 *   return (
 *     <Card>
 *       <ProcessingSpinner message="Extracting tables from your PDF..." />
 *     </Card>
 *   );
 * }
 */
